export enum Routes {
	Monitoring = '/',
	Alerts = '/alerts',
	Repository = '/repository',
	Login = '/login',
	Servers = '/servers',
	Tasks = '/tasks'
}
